globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};
appCustomerSpace.Controllers.LocalManagement.Multicast = appCustomerSpace.Controllers.LocalManagement.Multicast || {};


appCustomerSpace.Controllers.LocalManagement.Multicast.AppleBusinessConnectController = (function (superClass) {

  utils.extend(AppleBusinessConnectController, superClass);

  function AppleBusinessConnectController() {
    return AppleBusinessConnectController.__super__.constructor.apply(this, arguments);
  }

  $.extend(AppleBusinessConnectController.prototype, {
    init: function () {
      this.initEvents();

      return AppleBusinessConnectController.__super__.init.apply(this, arguments);
    },
    initEvents: function () {
      $('input[name=accept_multicast').on('change', function () {
        $('.enable-multicast').attr('disabled', !$(this).is(':checked'));
      });
    }
  });

  return AppleBusinessConnectController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
